import React from "react";
import "../../BookingDetailsComponent/flight.css";

const StepCheck = (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path
            d="M5 12.5l4.5 4.5L19 7"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const BookingStepProgress = ({ currentTab, tab2SubStep = "review" }) => {
    const tab1Active = currentTab?.["1"]?.active;
    const tab2Active = currentTab?.["2"]?.active;

    if (!tab1Active && !tab2Active) return null;

    const onPayment = tab2Active && tab2SubStep === "payment";
    const onReview = tab2Active && tab2SubStep === "review";

    const steps = [
        {
            n: 1,
            label: "Traveler Details",
            active: tab1Active,
            done: currentTab?.["1"]?.success,
        },
        {
            n: 2,
            label: "Review",
            active: onReview,
            done: onPayment,
        },
        {
            n: 3,
            label: "Payment",
            active: onPayment,
            done: false,
        },
    ];

    return (
        <ol className="hw-exchk--steps">
            {steps.map(({ n, label, active, done }) => (
                <li
                    key={n}
                    className={`hw-exchk--step${active ? " is-active" : ""}${done ? " is-done" : ""}`}
                >
                    <span className="hw-exchk--stepNum">
                        {done ? StepCheck : n}
                    </span>
                    <span className="hw-exchk--stepLabel">{label}</span>
                </li>
            ))}
        </ol>
    );
};

export default BookingStepProgress;